import { FC } from 'react';
import { Award } from 'lucide-react';
import { SpecialtyTags } from './SpecialtyTags';

export interface SpecialtiesSectionProps {
  specialties: string[];
  onChange: (specialties: string[]) => void;
}

export const SpecialtiesSection: FC<SpecialtiesSectionProps> = ({
  specialties,
  onChange,
}) => {
  return (
    <div className="bg-white dark:bg-slate-800 rounded-lg border border-gray-200 dark:border-slate-700 p-6">
      <h3 className="text-lg font-semibold text-gray-900 dark:text-slate-100 mb-4 flex items-center gap-2">
        <Award className="w-5 h-5" />
        Specialties
      </h3>
      <p className="text-sm text-gray-600 dark:text-slate-400 mb-4">
        Add your massage therapy specialties. These help clients find you.
      </p>
      <SpecialtyTags specialties={specialties} onChange={onChange} />
    </div>
  );
};
